import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userToken, setUserToken] = useState(() =>
    localStorage.getItem("login-token")
  );

  const login = (token) => {
    localStorage.setItem("login-token", token);
    setUserToken(token);
  };

  const logout = () => {
    localStorage.removeItem("login-token");
    setUserToken(null);
  };

  return (
    <AuthContext.Provider value={{ userToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
